import { Injectable } from '@angular/core';

import iziToast, { IziToastSettings } from 'izitoast';
import { Observable, Subject } from 'rxjs';

import { StringUtil } from '../utils/string-util';


export enum Duracao {
    MUITO_CURTO = 2000
  , CURTO = 5000
  , MEDIO = 10000
  , DEMORADO = 15000
  , MUITO_DEMORADO = 30000
  , FIXO = 0
}

export enum TipoInput {
  NUMBER = 'number',
  TEXT = 'text'
}

@Injectable({
  providedIn: 'root'
})
export class ToasterService {

    private toastyService = iziToast;

    error(titulo?: string, msg?: string, timeout?: Duracao) {
        if (!titulo) {
          titulo = 'Ocorreu um erro na operação!';
        }
        this.toastyService.error(this.montaToast(titulo, msg, timeout));
    }

    success(titulo?: string, msg?: string, timeout?: Duracao) {
        if (!titulo) {
          titulo = 'Operação realizada com sucesso!';
        }
        timeout = ( timeout ? timeout : Duracao.MUITO_CURTO );
        this.toastyService.success(this.montaToast(titulo, msg, timeout));
    }

    info(titulo: string, msg?: string, timeout?: Duracao) {
        this.toastyService.info(this.montaToast(titulo, msg, timeout));
    }

    warning(titulo: string, msg?: string, timeout?: Duracao) {
        this.toastyService.warning(this.montaToast(titulo, msg, timeout));
    }

    loading(): number {
      return this.wait();
    }

    wait(titulo?: string, toasterWaitId?: number): number {

      // não re-exibir toaster
      if ( toasterWaitId ) {
        const toast: any = document.querySelector('#iziToastId_' + toasterWaitId);
        if ( toast ) {
         return toasterWaitId;
        }
      }

      toasterWaitId = toasterWaitId ? toasterWaitId : StringUtil.getRandomInt();

      titulo = ( titulo ? titulo : 'Por favor, aguarde...' );
      const iziToastSettings = this.montaToast(titulo);
      iziToastSettings.color = 'dark';
      iziToastSettings.theme = 'dark';
      iziToastSettings.id = 'iziToastId_' + toasterWaitId;
      iziToastSettings.timeout = false;
      // iziToastSettings.progressBarColor = 'rgb(0, 255, 184)';
      // iziToastSettings.icon = 'fa-spin';
      // iziToastSettings.progressBar = true;

      // http://samherbert.net/svg-loaders/
      iziToastSettings.image = 'assets/layout/svg/loaders/oval.svg';
      iziToastSettings.imageWidth = 22;

      setTimeout(() => {
        // não re-exibir toaster
        if ( toasterWaitId ) {
          const toast: any = document.querySelector('#iziToastId_' + toasterWaitId);
          if ( toast ) {
            return
          }
        }

        iziToast.show(iziToastSettings);
      }
      , 1);

      return toasterWaitId;
    }

    montaToast(titulo: string, msg?: string, timeout?: Duracao): IziToastSettings {
      timeout = ( timeout === undefined ? Duracao.CURTO : timeout );
      msg = ( msg ? msg : '' );

      const iziToastSettings: IziToastSettings = {
        title: titulo,
        message: msg,
        timeout: (timeout === Duracao.FIXO ? false : timeout),
        // position: 'topRight',
        position: 'bottomRight',
        closeOnClick: false,
        closeOnEscape: false,
        animateInside: true,
        transitionIn: 'flipInX',
        transitionOut: 'flipOutX',
        theme: 'light',
        titleSize: '13px',
        messageSize: '12px',
        class: 'iziToast',
        maxWidth: 350,
        overlay: false,
        zindex: 999999999,
        onOpened: () => {
        },
        onClosed: () => {
        }
      };

      return iziToastSettings;
    }

    clearWait(toasterWaitId?: number): void {
      setTimeout(() => this.clearWaitRunnable(toasterWaitId), 400); // 630
    }

    private clearWaitRunnable(toasterWaitId?: number) {
      if ( toasterWaitId ) {
        const toast: any = document.querySelector('#iziToastId_' + toasterWaitId);
        if ( toast ) {
         iziToast.hide({}, toast);
        }
      }
      else {
        const toasts: NodeListOf<any> = document.querySelectorAll("div[id^='iziToastId_']");
        if ( toasts ) {
          toasts.forEach(toast => {
            iziToast.hide({}, toast);
          });
        }
      }
    }

    abrirPopupComInputs(titulo: string,
                        mensagem: string,
                        okButtonLabel?: string,
                        cancelButtonLabel?: string,
                        tipoInput?: TipoInput
                        ): Observable<HTMLInputElement[]> {
      const subject = new Subject<HTMLInputElement[]>();

      okButtonLabel     = ( okButtonLabel ? okButtonLabel : 'Confirmar' );
      cancelButtonLabel = ( cancelButtonLabel ? cancelButtonLabel : 'Cancelar' );
      tipoInput         = ( tipoInput ? tipoInput : TipoInput.TEXT );

      iziToast.question({
        rtl: false,
        layout: 1,
        drag: false,
        timeout: false,
        close: false,
        overlay: true,
        displayMode: 1,
        id: 'question',
        progressBar: true,
        title: titulo,
        message: mensagem,
        position: 'center',
        animateInside: false,
        closeOnEscape: true,
        inputs: [
            /*
            ['<input type="text">', 'keyup', function (instance, toast, input, e) {
                console.info(e);
                console.info(input);
            }, true],*/
            ['<input type="'+ tipoInput.toString() +'">',
             'keydown',
             function (instance, toast, input, e) {
                // console.info(e);
                // console.info(input);
                if ( e['keyCode'] === 13 ) {
                  subject.next([input]);
                  subject.complete();
                  instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
                  e.stopPropagation();
                }
             }
             , true
            ]
            /*['<select><option value="Select">Select</option><option value="10 ~ 20">10 ~ 20</option><option value="21 ~ 30">21 ~ 30</option><option value="31 ~ 40">31 ~ 40</option><option value="40+">40+</option></select>', 'change', function (instance, toast, select, e) {
                 console.info(select.options[select.selectedIndex].value);
                 // console.info(select);
            }]*/
        ],
        buttons: [
            ['<button><b>' + okButtonLabel + '</b></button>', function (instance, toast, button, e, inputs) {
                // console.info(button);
                // console.info(e);
                subject.next(inputs);
                subject.complete();
                // alert(inputs[0].options[inputs[0].selectedIndex].value)
                instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
                e.stopPropagation();
               /* iziToast.success({
                    id: 'success',
                    zindex: 9999,
                    timeout: 2000,
                    title: 'Success',
                    overlay: true,
                    message: 'Thank you',
                    position: 'center'
                });*/

            }, false], // true to focus
            ['<button>' + cancelButtonLabel + '</button>', function (instance, toast, button, e) {
                // console.info(button);
                // console.info(e);
                subject.next(null);
                subject.complete();
                instance.hide({ transitionOut: 'fadeOut' }, toast, 'button');
                e.stopPropagation();
            }, false]
        ],
        onClosing: function(instance, toast, closedBy){
            // console.info('Closing | closedBy: ' + closedBy);
        },
        onClosed: function(instance, toast, closedBy){
            // console.info('Closed | closedBy: ' + closedBy);
        }
      });

      return subject.asObservable();
    }
}
